/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StageAltArtRequest } from '../../models/stage-alt-art-request';
import { StageAltArtResponse } from '../../models/stage-alt-art-response';

export interface AdminServiceStageAltArt$Params {
      body: StageAltArtRequest
}

export function adminServiceStageAltArt(http: HttpClient, rootUrl: string, params: AdminServiceStageAltArt$Params, context?: HttpContext): Observable<StrictHttpResponse<StageAltArtResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceStageAltArt.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StageAltArtResponse>;
    })
  );
}

adminServiceStageAltArt.PATH = '/api/v3/gateway/admin/stage/alt_art';
